"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ConstrainedFloatingPoint_1 = require("../../../util/types/ConstrainedFloatingPoint");
const ImprobedOpSet_1 = require("../../../cgp/operator-sets/ImprobedOpSet");
const CGPGenerator_1 = require("../../../cgp/CGPGenerator");
const CGPPointMutator_1 = require("../../../cgp/CGPPointMutator");
const NArmedBandit_1 = __importDefault(require("../../../problems/n-armed-bandit/NArmedBandit"));
const RecurrentCGPExecutor_1 = require("../../../cgp/RecurrentCGPExecutor");
exports.default = () => {
    const numBandits = 3;
    const numArms = 4;
    const numTurns = 100;
    const cgpConfig = {
        numInputs: numArms + numBandits * 2 + 1,
        numMiddleNodes: 100,
        numOutputs: numArms,
        nodeInputCount: 3,
        operators: ImprobedOpSet_1.ImprobedOpSet
    };
    const generator = new CGPGenerator_1.CGPGenerator(cgpConfig);
    const mutator = new CGPPointMutator_1.CGPPointMutator(cgpConfig);
    const pool = Array.from({ length: 5 }, (_, i) => generator.generate());
    const [bestScore, setBestScore] = React.useState(0);
    const [parent, setParent] = React.useState(pool[0]);
    const [generation, setGeneration] = React.useState(1);
    const [bandit, setBandit] = React.useState(new NArmedBandit_1.default(numBandits, numArms, numTurns));
    const [lastBanditScores, setLastBanditScores] = React.useState([]);
    function runGenerations(count) {
        return __awaiter(this, void 0, void 0, function* () {
            let i = 0;
            let localParent = parent;
            let localGeneration = generation;
            let localBandit = new NArmedBandit_1.default(numBandits, numArms, numTurns);
            (function run() {
                return __awaiter(this, void 0, void 0, function* () {
                    // Nice part is we already have the fitnesses:
                    pool[0] = localParent;
                    for (let i = 1; i < pool.length; i++) {
                        pool[i] = mutator.mutate(localParent);
                    }
                    let currentPoolBest = -1000000;
                    localBandit = new NArmedBandit_1.default(numBandits, numArms, numTurns);
                    for (let i = 0; i < pool.length; i++) {
                        const executor = new RecurrentCGPExecutor_1.RecurrentCGPExecutor(pool[i], cgpConfig, (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(0.0));
                        localBandit.reset();
                        while (!localBandit.done) {
                            const state = localBandit.getStateConstrained();
                            const outputs = executor.execute(state);
                            // Get the *hot* action:
                            const action = outputs.reduce((iMax, x, i, arr) => x > arr[iMax] ? i : iMax, 0);
                            localBandit.setAction(action);
                        }
                        const score = localBandit.currentTotalReward;
                        if (score >= currentPoolBest) {
                            currentPoolBest = score;
                            localParent = pool[i];
                            setParent(pool[i]);
                        }
                    }
                    setBandit(localBandit);
                    setBestScore(currentPoolBest);
                    localGeneration++;
                    setGeneration(localGeneration);
                    i++;
                    if (i < count) {
                        setTimeout(run, 0);
                    }
                    else {
                    }
                });
            })();
        });
    }
    function renderControls() {
        return (React.createElement("div", null,
            "Best score: ",
            bestScore,
            React.createElement("br", null),
            "Generation: ",
            generation,
            React.createElement("br", null),
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    runGenerations(1);
                }) }, "Run 1 generation"),
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    runGenerations(100);
                }) }, "Run 100 generations"),
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    runGenerations(1000);
                }) }, "Run 1000 generations")));
    }
    function showBest(parent, bandit) {
        return (React.createElement("div", null,
            React.createElement("button", { type: "button", onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    const bestData = [];
                    const executor = new RecurrentCGPExecutor_1.RecurrentCGPExecutor(parent, cgpConfig, (0, ConstrainedFloatingPoint_1.asConstrainedFloatingPoint)(0.0));
                    bandit.reset();
                    while (!bandit.done) {
                        const luck = bandit.currentLuck;
                        const state = bandit.getStateConstrained();
                        const outputs = executor.execute(state);
                        // Get the *hot* action:
                        const action = outputs.reduce((iMax, x, i, arr) => x > arr[iMax] ? i : iMax, 0);
                        bandit.setAction(action);
                        bestData.push({
                            bandit: bandit.lastBandit,
                            armChosen: bandit.lastArmChoice,
                            reward: bandit.lastTurnReward,
                            luck
                        });
                    }
                    setLastBanditScores(bestData);
                }) }, "Show best program on last bandit"),
            React.createElement("br", null),
            "Last bandit config:",
            React.createElement("table", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Bandit"),
                    React.createElement("th", null, "Arm"),
                    React.createElement("th", null, "Cost"),
                    React.createElement("th", null, "Reward"),
                    React.createElement("th", null, "Threshold"),
                    React.createElement("th", null, "Expected Value")),
                bandit.banditConfig.map((row, i) => (React.createElement(React.Fragment, null, row.map((arm, j) => (React.createElement("tr", null,
                    React.createElement("td", null, i),
                    React.createElement("td", null, j),
                    React.createElement("td", null, arm.cost),
                    React.createElement("td", null, arm.reward),
                    React.createElement("td", null, arm.threshold),
                    React.createElement("td", null, arm.reward * (1 - arm.threshold) - arm.cost * arm.threshold)))))))),
            React.createElement("br", null),
            React.createElement("table", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Bandit"),
                    React.createElement("th", null, "Arm Chosen"),
                    React.createElement("th", null, "Luck"),
                    React.createElement("th", null, "Reward")),
                lastBanditScores.map((row, i) => (React.createElement("tr", null,
                    React.createElement("td", null, row.bandit),
                    React.createElement("td", null, row.armChosen),
                    React.createElement("td", null, row.luck),
                    React.createElement("td", null, row.reward)))))));
    }
    return (React.createElement("div", null,
        React.createElement("p", null, "Here's an interesting problem: N-Armed Bandit."),
        React.createElement("p", null, "There are a series of slot machine with N arms. Given a machine, you have to pick an arm, at which time you either win (getting a reward) or lose (paying the cost of pulling that arm)."),
        React.createElement("p", null, "It's a classic problem between exploration, trying different arms to see what the potential win rates/rewards are, vs exploitation where you take advantage of what you know to try and maximize your reward."),
        React.createElement("p", null, "Now, I could fix the problem, throw GP at it, and it'd probably find a good solution for a given problem. ie: it'd figure out which arms on which slot machines are the most rewarding."),
        React.createElement("p", null, "But let's make this a bit more interesting, and change the rates each run. That is, rather than figuring out the best arms for a given slot machine set, it has to figure out *how* to figure out the best arms. Basically, figuring out the balance between exploration and explotation."),
        React.createElement("p", null, "To facilitate this, we will feedback the reward and last choice as part of the state. This means that the program will need some way to keep track of state, so we'll be trying RCGP again here."),
        React.createElement("p", null, "In theory, if a program has been trained properly, it should explore (try a couple different arms), then exploit the best arms."),
        renderControls(),
        showBest(parent, bandit)));
};
